module.exports = __webpack_public_path__ + "media/images/office-42137d7a96f413e995d9950f3a04a572.svg";